__turbopack_context__.v({
  "modal": "PageSubscriptionButton-module-scss-module__4_alxq__modal",
  "modalContent": "PageSubscriptionButton-module-scss-module__4_alxq__modalContent",
  "modalSubtitle": "PageSubscriptionButton-module-scss-module__4_alxq__modalSubtitle",
  "subscribeButton": "PageSubscriptionButton-module-scss-module__4_alxq__subscribeButton",
});
